 <app-table-title [title]="'INVESTMENTS' | dictionary" [introText]="introText"></app-table-title>

 <div class="row">
   <div class="col-lg-12">
     <div class="m-portlet m-portlet--unair" style="margin-bottom: 0px;">
       <div class="pr-2 home-middle-header-bgcolor" style="display: flex;">


         <div class="form-row col-lg-12 pt-2 pb-2">
                     <div class="col-md-6 col-sm-12 filter-wrapper">
                       <label class="text-right text-color-1 filter-label">{{'FUND' | dictionary}}</label>
                       <div style="padding: 0;width: calc(100% - 100px);">
                         <select class="form-control" [(ngModel)]="fund" (ngModelChange)="search()">
                           <option *ngFor="let fund of funds" [value]="fund.FundId">{{fund.Title}}</option>
                         </select>
                       </div>
                     </div>
           <div class="col-md-6 col-sm-12 filter-wrapper">
             <input class="checkbox-field" type="checkbox" [(ngModel)]="isActiveOnly" (ngModelChange)="search()"/>
             <label class="margin-0 text-color-1">{{'ACTIVE' | dictionary}}</label>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>
 <div class="row table-container">
   <div class="col-lg-12 table-container">
     <!--                                       grid                         -------------------------------- -->
     <kendo-grid #kendoGridComponent [data]="allInvestments" [loading]="loading"
                 [navigable]="false"
                 [resizable]="true"
                 [sortable]="config.sortable" [sort]="sort" [selectable]="config.selectable"
                 (sortChange)="sortChange($event)">

       <kendo-grid-column
         [headerStyle]="{'white-space': 'normal', 'vertical-align': 'top'}" [style]="{'text-align': c.align || 'left'}"
         *ngFor="let c of config.columns" [headerClass]="'gridheader text-color-1'" field="{{c.field}}"
                          [width]="c.width" title="{{c.title}}" [sortable]="c.sortable">
         <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
           <span [title]="c.title">{{c.title}}</span>
         </ng-template>

         <ng-template kendoGridCellTemplate let-dataItem>
           <span *ngIf="!c.formatPattern && !c.dateFormat && !c.applyMask">{{dataItem[c.field]}}</span>
           <app-secure-mask *ngIf="c.applyMask && !c.formatPattern && !c.dateFormat " [value]="dataItem[c.field]"></app-secure-mask>
           <span *ngIf="c.dateFormat && !c.formatPattern && !c.applyMask">{{dataItem[c.field] | date : c.dateFormat}}</span>
           <FormatLabel [class.red]="dataItem[c.field] < 0" *ngIf="c.formatPattern && !c.applyMask && !c.dateFormat" [Text]="dataItem[c.field]"
                        [FormatPattern]="c.formatPattern"></FormatLabel>
         </ng-template>

       </kendo-grid-column>

       <ng-template kendoGridDetailTemplate let-dataItem>
         <app-investment-detail [investment]="dataItem"></app-investment-detail>
       </ng-template>
     </kendo-grid>
   </div>
 </div>
 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">

 </app-pop-up-dialog>
